/* ------------------------------------------------------------------ */
/* Badges reutilizáveis — Mapa de Integrações                           */
/* ------------------------------------------------------------------ */

export type Status = 'ativo' | 'bypass' | 'bloqueado' | 'pendente' | 'arquivado';
export type NivelAcesso = 'api-publica' | 'mni-restrito' | 'so-scraping' | 'inacessivel';
export type StatusProAdv = 'ativo' | 'planejado' | 'bloqueado' | 'sem-plano';

export const statusConfig: Record<
  Status,
  { label: string; bg: string; text: string; dot: string; descricao: string }
> = {
  ativo: {
    label: 'Ativo',
    bg: 'bg-green-500/15',
    text: 'text-green-400',
    dot: 'bg-green-400',
    descricao: 'Funcional em produção',
  },
  bypass: {
    label: 'Ativo (bypass)',
    bg: 'bg-yellow-500/15',
    text: 'text-yellow-400',
    dot: 'bg-yellow-400',
    descricao: 'Funcional via workaround',
  },
  bloqueado: {
    label: 'Bloqueado',
    bg: 'bg-red-500/15',
    text: 'text-red-400',
    dot: 'bg-red-400',
    descricao: 'Aguarda recurso externo',
  },
  pendente: {
    label: 'Pendente',
    bg: 'bg-zinc-500/15',
    text: 'text-zinc-400',
    dot: 'bg-zinc-400',
    descricao: 'Não implementado',
  },
  arquivado: {
    label: 'Arquivado (MVP)',
    bg: 'bg-zinc-500/10',
    text: 'text-zinc-500',
    dot: 'bg-zinc-500',
    descricao: 'Fora do escopo do MVP',
  },
};

export const nivelAcessoConfig: Record<
  NivelAcesso,
  { label: string; bg: string; text: string; dot: string; descricao: string }
> = {
  'api-publica': {
    label: 'API Pública',
    bg: 'bg-green-500/15',
    text: 'text-green-400',
    dot: 'bg-green-400',
    descricao: 'Endpoints REST/SOAP documentados e acessíveis para terceiros sem credencial especial',
  },
  'mni-restrito': {
    label: 'MNI Restrito',
    bg: 'bg-yellow-500/15',
    text: 'text-yellow-400',
    dot: 'bg-yellow-400',
    descricao: 'Webservice existe mas só para órgãos do Judiciário credenciados (MP, Defensoria, outros tribunais)',
  },
  'so-scraping': {
    label: 'Só Scraping',
    bg: 'bg-orange-500/15',
    text: 'text-orange-400',
    dot: 'bg-orange-400',
    descricao: 'Sem API oficial — acesso programático apenas via scraping autenticado com certificado digital',
  },
  inacessivel: {
    label: 'Inacessível',
    bg: 'bg-red-500/15',
    text: 'text-red-400',
    dot: 'bg-red-400',
    descricao: 'Sistema fechado ou sem portal de acesso para escritórios privados',
  },
};

export const statusProAdvConfig: Record<
  StatusProAdv,
  { label: string; bg: string; text: string }
> = {
  ativo: { label: 'Ativo', bg: 'bg-green-500/15', text: 'text-green-400' },
  planejado: { label: 'Planejado', bg: 'bg-blue-500/15', text: 'text-blue-400' },
  bloqueado: { label: 'Bloqueado', bg: 'bg-red-500/15', text: 'text-red-400' },
  'sem-plano': { label: 'Sem plano', bg: 'bg-zinc-500/15', text: 'text-zinc-400' },
};

export function StatusBadge({ status }: { status: Status }) {
  const cfg = statusConfig[status];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ${cfg.bg} ${cfg.text}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${cfg.dot}`} />
      {cfg.label}
    </span>
  );
}

export function NivelBadge({ nivel }: { nivel: NivelAcesso }) {
  const cfg = nivelAcessoConfig[nivel];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ${cfg.bg} ${cfg.text}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${cfg.dot}`} />
      {cfg.label}
    </span>
  );
}

export function StatusProAdvBadge({ status }: { status: StatusProAdv }) {
  const cfg = statusProAdvConfig[status];
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${cfg.bg} ${cfg.text}`}
    >
      {cfg.label}
    </span>
  );
}
